import { InboxComponent } from './../Inbox.component';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  EmailAddress,
  InternalRowsArray,
  NewEmail,
} from '../InboxInterfaces/newEmail';
import { InboxService } from 'src/app/services/InboxService.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-ComposeEmail',
  templateUrl: './ComposeEmail.component.html',
  styleUrls: ['./ComposeEmail.component.css'],
})
export class ComposeEmailComponent implements OnInit {
  config: any = {
    airMode: false,
    tabDisable: true,
    popover: {
      table: [
        ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
        ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
      ],
      link: [['link', ['linkDialogShow', 'unlink']]],
      air: [
        [
          'font',
          [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'superscript',
            'subscript',
            'clear',
          ],
        ],
      ],
    },
    height: '200px',
    toolbar: [
      ['misc', ['undo', 'redo']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear',
        ],
      ],
      ['fontsize', ['fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'link', 'hr']],
    ],
    codeviewFilter: true,
    codeviewFilterRegex:
      /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    codeviewIframeFilter: true,
  };
  internals: InternalRowsArray[] = [];
  newEmail: FormGroup = new FormGroup({
    to: new FormControl(null),
    to_usercode: new FormControl(null),
    cc: new FormControl(null),
    bcc: new FormControl(null),
    subject: new FormControl(null),
    body: new FormControl(null),
  });
  ifCC = false;
  ifBcc = false;
  newEmailObject!: NewEmail;
  newEmailFormData!: FormData;
  Emails: EmailAddress[] = [];
  replyText: any;

  loading = false;

  constructor(
    private general: InboxService,
    private message: NzMessageService,
    private route: ActivatedRoute,
    private inboxComponent: InboxComponent,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params.replyCode) {
        this.general
          .getOrginalMessageForReply(params.replyCode)
          .subscribe((reply: string) => {
            let test = reply.replace('\r\n', '<br>');
            test = '<br> <br>' + test;
            console.log(test);
            this.newEmail.get('body').setValue(test);
          });
      }
    });
    this.getListOfEmails();
    this.getInternals();
    this.newEmailFormData = new FormData();
  }
  onBack() {
    this.inboxComponent.isCollapsed = !this.inboxComponent.isCollapsed;
  }

  getListOfEmails() {
    this.general.getListOfEmails().subscribe((data) => {
      this.Emails = data;
    });
  }
  getInternals() {
    this.general.getInternals().subscribe((data) => {
      this.internals = data.rowsArray;
    });
  }

  SendMessage() {
    this.newEmailObject = this.newEmail.value;
    this.newEmailObject.to = this.newEmailObject.to == null ? '' : this.newEmailObject.to.join(',');
    this.loading = true;
    this.general.SendNewEmail(this.newEmailObject).subscribe(
      (d: any) => {
        // console.log({ d: d });
        this.loading = false;
        if (d.ISuccess === 0 || d.Success === 0) {
          if (d.ISuccess === 0) {
            this.message.create('error', d.IMessage);
          }
          if (d.Success === 0) {
            this.message.create('error', d.Message);
          }
        } else {
          this.message.create('success', 'message sent successfuly');
          this.router.navigate(['/apps/crm/inbox/inboxMail']);
        }
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }
}
